import { Box, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

import theme from "@/theme";

const useStyles = makeStyles(() => ({
  root: { display: "flex", alignItems: "flex-start", gap: 8 },
  icon: { display: "block", flexShrink: 0 },
  text: {
    minWidth: 0,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
    [theme.breakpoints.up("md")]: { fontSize: 14 },
  },
}));

export const RegistrationHelpText: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className,
}) => {
  const classes = useStyles();
  return (
    <Box className={`${classes.root} ${className ?? ""}`}>
      <img src="/icons/ds-v2-info.svg" alt="" aria-hidden="true" className={classes.icon} />
      <Typography className={classes.text}>{children}</Typography>
    </Box>
  );
};
